import {
  Badge,
  Button,
  RefreshIcon,
  SegmentedControl,
  SegmentedControlButton,
} from '@forge/common';

export type RangeMonths = 3 | 6 | 12;

interface DashboardHeaderProps {
  isUsingMockData: boolean;
  updatedLabel?: string;
  rangeMonths: RangeMonths;
  onRangeChange: (months: RangeMonths) => void;
  onRefresh: () => void;
}

const ranges: { value: RangeMonths; label: string }[] = [
  { value: 3, label: '3M' },
  { value: 6, label: '6M' },
  { value: 12, label: '12M' },
];

const DashboardHeader = ({
  isUsingMockData,
  updatedLabel,
  rangeMonths,
  onRangeChange,
  onRefresh,
}: DashboardHeaderProps) => {
  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
      <div className="space-y-2">
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100 md:text-3xl">
            Platform Dashboard
          </h1>
          <Badge color={isUsingMockData ? 'orange' : 'green'}>
            {isUsingMockData ? 'Preview data' : 'Live data'}
          </Badge>
        </div>
        <p className="max-w-2xl text-sm text-color-tertiary md:text-base">
          Track milestones, delivery momentum, and release activity across the
          OneRing platform.
          {updatedLabel ? ` Updated ${updatedLabel}.` : ''}
        </p>
      </div>

      <div className="flex items-center gap-3">
        <SegmentedControl
          id="dashboard-range"
          size="small"
          onChange={(event) =>
            onRangeChange(Number(event.target.value) as RangeMonths)
          }
        >
          {ranges.map((range) => (
            <SegmentedControlButton
              key={range.value}
              id={`dashboard-range-${range.value}`}
              value={String(range.value)}
              defaultChecked={range.value === rangeMonths}
            >
              {range.label}
            </SegmentedControlButton>
          ))}
        </SegmentedControl>
        <Button
          variant="secondary"
          onClick={onRefresh}
          icon={<RefreshIcon className="h-4 w-4" aria-hidden />}
        >
          Refresh
        </Button>
      </div>
    </div>
  );
};

export type { DashboardHeaderProps };
export default DashboardHeader;
